import { OsadDetails } from "../../hooks/react-query/outbound/freightDetails/useGetOsadDetails";

export const osadSummaryAndShipments = {
  default: {
    summary: {
      areaName: "OSAD",
      bills: 4,
      pieces: 2,
      pallets: 2,
      weight: 3322,
      handlingUnits: 0,
      billsByTags: [
        { id: 2, name: "UC", color: "#FBC02D", bills: 1, position: 20 },
        { id: 81, name: "VC", color: "#AA7EA0", bills: 1, position: 40 },
        { id: 6, name: "LG", color: "#679CB2", bills: 2, position: 50 },
        { id: 75, name: "OVL", color: "#C77563", bills: 2, position: 80 },
        { id: 5, name: "APTM", color: "#69ADA8", bills: 1, position: 110 },
        { id: 4, name: "APTR", color: "#777DE9", bills: 1, position: 120 },
        { id: 9, name: "DTCL", color: "#5E9FE0", bills: 1, position: 190 },
      ],
    },
    shipments: [
      {
        shipmentId: 135280698,
        proNumber: "160160594",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 1,
        pieces: 2,
        weight: 1210,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 5,
            name: "APTM",
            description: "",
            color: "#69ADA8",
            position: 110,
            bills: 1,
          },
        ],
        originSic: "ONT",
        destinationSic: "EWR",
        finalDestinationSic: "PHL",
        status: "UNLD",
        dueServiceDate: "2025-11-03",
        loadToSicId: 1,
        loadTo: "PHL",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: "DAL-1234",
          pullId: 891027,
          trapId: 160160594,
          tripNumber: 1,
        },
      },
    ],
  },
} as const satisfies Record<string, OsadDetails>;
